const voirLeLookPdp = document.querySelector(".voir-le-look-pdp");

if (voirLeLookPdp) {
  voirLeLookPdp.addEventListener("click", function () {
    const voidLookMain = document.querySelector(".void-look-main");
    voidLookMain.classList.add("active-vlook");
  });

  const voidLookCross = document.querySelector(".void-look-cross");

  if (voidLookCross) {
    voidLookCross.addEventListener("click", function () {
      const voidLookMain = document.querySelector(".void-look-main");
      voidLookMain.classList.remove("active-vlook");
    });
  }

  let lastScrollV = 0;

  window.addEventListener("scroll", () => {
    const voidLookMain = document.querySelector(".void-look-main");

    if (voidLookMain) {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollV) {
        voidLookMain.classList.add("v-look-scroll");
      } else if (currentScrollY === 0) {
        voidLookMain.classList.remove("v-look-scroll");
      }
      lastScrollV = currentScrollY;
    }
  });
}
